(() => {
  // app/scripts/tooltip.js
  !window.customElements.get("tooltip-component") && window.customElements.define("tooltip-component", class tooltipComponent extends HTMLElement {
    constructor() {
      super();
      this.container = document.getElementById("popup-tooltip");
      this.changePositionTooltip();
      window.addEventListener("resize", () => {
        this.changePositionTooltip();
      });
    }
    changePositionTooltip() {
      document.querySelectorAll(".cc-multi-column .multi-column .tooltip-wrapper").forEach((btnTooltip) => {
        if (window.innerWidth >= 768) {
          btnTooltip.addEventListener("mouseenter", () => {
            this.container.classList.add("is-hover");
            this.template = btnTooltip.querySelector("[data-tooltip-template]")?.content;
            this.innerHTML = this.template.querySelector(".tooltip-content").innerHTML;
            const btnRect = btnTooltip.getBoundingClientRect();
            const tooltipRect = this.container.getBoundingClientRect();
            const viewportWidth = window.innerWidth;
            let left = btnRect.left + btnRect.width / 2 - tooltipRect.width / 2 + 50;
            let top = btnRect.top + 22;
            let right = "auto";
            if (left + tooltipRect.width > viewportWidth) {
              left = "auto";
              right = 20;
            } else {
              right = "initial";
            }
            this.container.style.position = "fixed";
            this.container.style.left = isNaN(left) ? left : `${left}px`;
            this.container.style.top = `${top}px`;
            this.container.style.right = isNaN(right) ? right : `${right}px`;
            const newTooltipRect = this.container.getBoundingClientRect();
            const arrowPosition = btnRect.left + btnRect.width / 2 - newTooltipRect.left;
            this.container.style.setProperty("--position-left", isNaN(left) ? `${arrowPosition - 2}px` : "31%");
          });
          this.container.addEventListener("mouseenter", () => {
            this.container.classList.add("is-hover");
          });
          this.container.addEventListener("mouseleave", () => {
            this.container.classList.remove("is-hover");
          });
          btnTooltip.addEventListener("mouseleave", () => {
            this.container.classList.remove("is-hover");
          });
        } else {
          btnTooltip.addEventListener("click", () => {
            this.template = btnTooltip.querySelector("[data-tooltip-template]")?.content;
            this.innerHTML = this.template.querySelector(".tooltip-content").innerHTML;
          });
        }
      });
    }
  });
  document.addEventListener("click", (e) => {
    if (!e.target.closest(".tooltip-wrapper"))
      return;
    e.preventDefault();
    document.querySelector("#popup-tooltip").open();
  });
})();
